import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Benefits from './components/Benefits';
import ContactSnippet from './components/ContactSnippet';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const localBusiness = {
      '@context': 'https://schema.org',
      '@type': 'InsuranceAgency',
      name: 'InsuranceServicesTX',
      url: siteUrl,
      telephone: '+1-512-306-6245',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '8708 S Congress Ave',
        addressLocality: 'Austin',
        addressRegion: 'TX',
        postalCode: '78745',
        addressCountry: 'US',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 30.1874,
        longitude: -97.7831,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: [
            'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday',
          ],
          opens: '09:00',
          closes: '13:00',
        },
      ],
      description:
        'InsuranceServicesTX provides personalized private health insurance in Austin, TX including Medicare Advantage, individual & family plans, and group health for small businesses.',
      areaServed: {
        '@type': 'City',
        name: 'Austin',
      },
      serviceType: [
        'Private Health Insurance',
        'Medicare Insurance',
        'Individual Health Insurance',
        'Group Health Insurance',
      ],
      priceRange: '$$',
    };

    const faq = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What private health insurance plans do you offer in Austin, TX?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'InsuranceServicesTX offers Medicare Advantage and supplemental plans for seniors over 65, individual and family private health insurance for those under 65, and affordable group health plans for small businesses in Austin, TX.',
          },
        },
        {
          '@type': 'Question',
          name: 'How can I get a free health insurance quote?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'You can call us at 512-306-6245 or fill out the contact form on our website to receive a personalized private health insurance quote at no cost.',
          },
        },
        {
          '@type': 'Question',
          name: 'Do you offer Medicare plans for seniors in Austin?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, we specialize in Medicare Advantage and supplemental private health insurance plans for individuals over 65 in Austin, TX.',
          },
        },
        {
          '@type': 'Question',
          name: 'What does group health insurance cover for small businesses?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Our group health insurance plans for small businesses in Austin cover medical visits, dental, eye care, and prescriptions, providing affordable private health insurance options for your team.',
          },
        },
      ],
    };

    const injectScript = (id: string, data: object) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    };

    injectScript('schema-local-business', localBusiness);
    injectScript('schema-faq', faq);

    return () => {
      document.getElementById('schema-local-business')?.remove();
      document.getElementById('schema-faq')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Benefits />
        <ContactSnippet />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
